<div class="cpcontent">
    <h2>Color Palettes</h2>
    Set in styles.css
    <br>
    <button class="btn btn-primary margin">Primary</button>
    <button class="btn btn-secondary margin">secondary</button>
    <button class="btn btn-success margin">success</button>
    <button class="btn btn-info margin">info</button>
    <button class="btn btn-warning margin">warning</button>
    <button class="btn btn-danger margin">danger</button>
    <br>
    <table class="table table-bordered ">
        <thead>
            <tr class="color-secondary">
                <th>Id</th>
                <th>Name</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Test</th>
                <th>Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td>Peter</td>
                <td>25</td>
                <td>male</td>
                <td>Test</td>
                <td>Delete</td>
            </tr>
            <tr>
                <td>2</td>
                <td>Cesar</td>
                <td>25</td>
                <td>male</td>
                <td>Test</td>
                <td>Delete</td>
            </tr>
            <tr>
                <td>3</td>
                <td>Elisabeth</td>
                <td>25</td>
                <td>male</td>
                <td>Test</td>
                <td>Delete</td>
            </tr>
            <tr>
                <td>1</td>
                <td>Peter</td>
                <td>25</td>
                <td>male</td>
                <td>Test</td>
                <td>Delete</td>
            </tr>
        </tbody>
    </table>
    
</div>
